import ShiftScheduler from "./ShiftScheduler";

export default function ManageShifts ({ activeTab }: {
    activeTab: string;
}) {
    return (
        <ShiftScheduler activeTab={activeTab} />
    );
}